import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/history/license.history.query.gql"
import type {
  LicenseHistoryQuery,
  LicenseHistoryQueryVariables,
} from "@/v2-backoffice-client/license/history/__types__/license.history.query"

type Options = QueryHookOptions<
  LicenseHistoryQuery,
  LicenseHistoryQueryVariables
>

export function useLicenseHistoryQuery(options?: Options) {
  return useQuery<LicenseHistoryQuery, LicenseHistoryQueryVariables>(
    query,
    options,
  )
}
